import UpdateLienCost from "../UpdateLienCost/UpdateLienCost";

const ViewLienCost = (props) => {
  return <UpdateLienCost {...props} viewMode={true} />;
};

export default ViewLienCost;
